import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/profile/cs_close.png'


const _hoisted_1 = { class: "popupContainer" }
const _hoisted_2 = { style: {"color":"#999","text-align":"center"} }
const _hoisted_3 = { class: "otp-input-container" }
const _hoisted_4 = ["onUpdate:modelValue", "onInput", "onKeydown"]

import { ref, PropType, computed } from 'vue'
import StatusPopup from '@/components/common/statusPopup.vue'
import LoadingScreen from '@/components/common/loadingScreen.vue'
import { useI18n } from 'vue-i18n';
import { getOtpVerification, getPhoneVerification } from '@/api/activity';
import MainButton from '../../components/common/mainButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'verifyPhonePopup',
  props: {
    list: {
        type: Array as PropType<(any)[]>,
        default: () => []
    },
    showIcon: {
        type: Boolean
    },
    isUseFirstRecharge: {
        type: Boolean,
        default: () => false
    }
},
  emits: ['updateInfo'],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props
const { t } = useI18n();
const show = ref(false)
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const title = ref('')
const loadingRef = ref()
const isShowOTP = ref(false)
const phoneNumber = ref('')
const otpFields = ref<any[]>(['', '', '', '', '', ''])
const otpCode = ref('')
const otpInput = ref()
const open = (data: any) => {
    show.value = true
    title.value = `R$ ${data} `
}

const close = () => {
    show.value = false
    phoneNumber.value = ''
    otpCode.value = ''
    otpFields.value = ['', '', '', '', '', '']
    isShowOTP.value = false

    if (otpInput.value && Array.isArray(otpInput.value)) {
    otpInput.value.forEach((input: any) => {
      if (input) input.value = ''
    })
  }
}
const emits = __emit
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}
const verifyPhone = () => {
    loadingRef.value.open()
    let data = {
        phoneNo: phoneNumber.value,
        area_code: "55"
    }
    getPhoneVerification(data).then(res => {
        loadingRef.value.close()
        showSuccess(res.msg)
        isShowOTP.value = true
    }).catch(err => {
        loadingRef.value.close()
        showError(err);
    })
}
const handleInput = (index: any, event: any) => {
    otpFields.value[index] = event.target.value

    if (event.target.value.length === 1 && index < otpFields.value.length - 1) {
        otpInput.value[index + 1].focus();
    }

    otpCode.value = otpFields.value.join('');
}
const handleBackspace = (index: any, event: any) => {
    if (event.target.value === '' && index > 0) {
        otpInput.value[index - 1].focus();
    }
}
const isPhoneVerifyActive = computed(() => {
    return (
        phoneNumber.value.length == 11
    );
});
const isOTPVerifyActive = computed(() => {
    return (
        otpCode.value.length == 6
    );
});
const submitOtp = () => {
    loadingRef.value.open()
    let data = {
        phoneNo: phoneNumber.value,
        area_code: 55,
        code: otpCode.value
    }
    getOtpVerification(data).then(res => {
        loadingRef.value.close()
        showSuccess(res.msg)
        setTimeout(() => {
            show.value = false
            emits('updateInfo')
        }, 500)
    }).catch(err => {
        loadingRef.value.close()
        showError(err);
    })
}
__expose({
    open,
    close
})

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_popup, {
      show: show.value,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((show).value = $event)),
      position: "bottom",
      style: {
        minWidth: '100%',
        minHeight: '45%',
        background: 'transparent',
        color: '#fff',
        overflow: 'hidden',
    }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_van_row, { class: "title" }, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, {
                span: "22",
                style: {"display":"flex","justify-content":"center","align-items":"center"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('activity.smsVerificatin')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, { span: "2" }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: _imports_0,
                    alt: "",
                    onClick: close
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (!isShowOTP.value)
            ? (_openBlock(), _createBlock(_component_van_row, {
                key: 0,
                justify: "center",
                class: "fieldContainer"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_col, {
                    span: "22",
                    style: {"margin-bottom":"15px"},
                    class: "input_container"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_field, {
                        class: "numberInput",
                        "label-width": "35px",
                        modelValue: phoneNumber.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((phoneNumber).value = $event)),
                        label: "+55",
                        "left-icon": "phone-o",
                        type: "number",
                        placeholder: _ctx.$t('loginRegister.phoneFormat')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_van_col, {
                    span: "16",
                    style: {"padding-top":"15px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(MainButton, {
                        title: _ctx.$t('activity.verify'),
                        activeStatus: isPhoneVerifyActive.value,
                        onClick: verifyPhone
                      }, null, 8, ["title", "activeStatus"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (isShowOTP.value)
            ? (_openBlock(), _createBlock(_component_van_row, {
                key: 1,
                justify: "center",
                class: "fieldContainer"
              }, {
                default: _withCtx(() => [
                  (isShowOTP.value)
                    ? (_openBlock(), _createBlock(_component_van_col, {
                        key: 0,
                        span: "24",
                        class: "inputCont"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('activity.enterOTPcode')), 1),
                          _createElementVNode("div", _hoisted_3, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(otpFields.value, (digit, index) => {
                              return _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: index,
                                "onUpdate:modelValue": ($event: any) => ((otpFields.value[index]) = $event),
                                maxlength: "1",
                                class: "otp-input",
                                type: "text",
                                inputmode: "numeric",
                                pattern: "[0-9]*",
                                onInput: ($event: any) => (handleInput(index, $event)),
                                onKeydown: _withKeys(($event: any) => (handleBackspace(index, $event)), ["backspace"]),
                                ref_for: true,
                                ref_key: "otpInput",
                                ref: otpInput
                              }, null, 40, _hoisted_4)), [
                                [_vModelText, otpFields.value[index]]
                              ])
                            }), 128))
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_van_col, {
                    span: "16",
                    style: {"padding-top":"15px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(MainButton, {
                        title: _ctx.$t('activity.verify'),
                        activeStatus: isOTPVerifyActive.value,
                        onClick: submitOtp
                      }, null, 8, ["title", "activeStatus"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(LoadingScreen, {
      ref_key: "loadingRef",
      ref: loadingRef
    }, null, 512),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"])
  ], 64))
}
}

})